/** For showing details like verified, platforms, tags e.t.c */

import {VNode} from 'snabbdom';

import {Directions} from 'common/components/drop-menu/types';
import type {Translatable, TranslationKey} from 'common/i18n';
import {User} from 'common/report/queries/app-api/data-definitions-types';
import {EntityType} from 'common/report/util/saved-entities/types';

export interface Detail {
  name: Translatable;
  value: TODO;
  type?: DetailType;
}

export enum DetailType {
  TextHighlight = `text-hightlight`,
  'User' = `user`,
  UserList = `user-list`,
  BrowseLink = `browse-link`,
  Text = `text`,
  SessionReplayPreview = `session-replay-preview`,
}

/** For showing metrics like counts, num of users e.t.c */
export interface Metric {
  icon: string;
  value: string | number;
  tooltip: Translatable;
  rank?: number;
  rankToolTip?: Translatable;
}

export enum ActionType {
  EditCustomEvent = `editCustomEvent`,
  EditCohort = `editCohort`,
  EditCustomProperty = `editCustomProperty`,
  ShareFormula = `shareFormula`,
  ShareMetric = `shareMetric`,
  ShareBehavior = `shareBehavior`,
  ShareCohort = `shareCohort`,
  ShareCustomEvent = `shareCustomEvent`,
  ShareCustomProperty = `shareCustomProperty`,
  ViewSampleEvents = `viewSampleEvents`,
  ViewEntity = `viewEntity`,
  LookupTableInfo = `lookupTableInfo`,
}

export interface Action {
  name: ActionType;
  label: Translatable;
  icon?: string;
  item?: any;
  disabled?: boolean;
  href?: string;
  readonly?: boolean;
  disabledTooltipText?: Translatable;
}

export interface EditItem {
  name?: string;
  type: string;
  id: string | number;
}

export interface Link {
  icon: string;
  href: string;
  tooltipText: Translatable;
}

export interface ImageInfo {
  imageUrl: string;
}

export interface ContextPanelData {
  header: Translatable;
  subHeader?: Translatable;
  path?: Translatable[]; // A list of formatted items representing the nested accessors of the entity (i.g. [Users], [User, LookupProp], [LookupProp])
  entityType?: EntityType;
  entityIcon?: string;
  entityReferencesCount?: number;
  entityName?: string;
  isUnsaved?: boolean;
  description?: Translatable;
  editItem?: EditItem;
  metrics?: Metric[];
  definitionDetails?: Detail[];
  definitionRenderer?: () => VNode;
  backgroundColor?: string;
  details?: Detail[];
  tags?: string[];
  queriedByUsers?: User[];
  extraInfo?: Translatable[];
  excludedMetricIcons?: string[];
  links?: Link[];
  actions?: Action[];
  isRecentlyUsed?: boolean;
  hasUnsavedChanges?: boolean;
  placement?: Directions;
  hideMetricsSection?: boolean;
  imageInfo?: ImageInfo[];
  // Temporary values for roll out of multi attribution. Should be deleted.
  showNewForFreeUsers?: boolean;
  noteForFreeUsers?: TranslationKey;
  // Used to break dependency cycle chain for session replay previews in context-panel
  rowDetailsReplayPreviewRenderer?: (eventName: string) => VNode;
  verified?: boolean;
  verifiedBy?: string;
  verifiedAt?: string;
}

export interface ContextPanelDataWithCondition extends ContextPanelData {
  condition?: () => boolean;
}
